<script lang="ts">
  import Compteur from '../../composants/Compteur.svelte'
  import Jauge from '../../composants/Jauge.svelte'
  import Pas from '../../composants/Pas.svelte'
  import type { Atelier } from '../../stores/creation.svelte'

  let { atelier }: { atelier: Atelier } = $props()

  const bareme = $derived(atelier.referentiel.bareme.caracteristiques)

  /** De combien avancent les boutons des six lignes. */
  let pas = $state(1)

  const caracs = $derived(atelier.referentiel.caracteristiques)

  const valeur = (id: string) =>
    atelier.feuille.caracteristiques[id] ?? bareme.valeur_de_depart

  /** D'où vient le relèvement, pour que le joueur sache pourquoi il l'a. */
  function origine(id: string): string {
    const r = atelier.referentiel.regions.find((x) => x.id === atelier.feuille.region)
    const c = atelier.referentiel.classes.find((x) => x.id === atelier.feuille.classe)
    const sources: string[] = []
    if (r?.caracteristiques_relevees.includes(id)) sources.push(r.nom)
    if (c?.caracteristiques_relevees.includes(id)) sources.push(c.nom)
    return sources.join(' + ')
  }
</script>

<p class="chapo">
  Chaque Caractéristique part de {bareme.valeur_de_depart} ; il y a
  {bareme.augmentations} Augmentations à répartir. Le plafond est de
  {bareme.plafond_a_la_creation}, relevé de 5 par la Région et de 5 par la Classe
  — les deux se cumulent. Les valeurs se saisissent aussi au clavier.
</p>

<div class="cartouche">
  <div class="bandeau">Augmentations de Caractéristique</div>
  <div class="corps">
    <Jauge
      budget={atelier.etat.caracteristiques.budget}
      depense={atelier.etat.caracteristiques.depense}
    />

    <div class="reglages">
      <Pas {pas} onchange={(v) => (pas = v)} />
    </div>

    <div class="lignes">
      {#each caracs as carac (carac.id)}
        {@const id = carac.id}
        {@const plafond = atelier.etat.plafonds[id] ?? bareme.plafond_a_la_creation}
        {@const source = origine(id)}
        <div class="ligne">
          <span class="nom">{carac.nom}</span>
          <span class="plafond">
            <span>plafond <span class="data">{plafond}</span></span>
            {#if source}<span class="source">{source}</span>{/if}
          </span>
          <Compteur
            valeur={valeur(id)}
            min={bareme.valeur_de_depart}
            max={plafond}
            libelle={carac.nom}
            {pas}
            onchange={(v) => atelier.fixerCarac(id, v)}
          />
        </div>
      {/each}
    </div>
  </div>
</div>

<style>
  .chapo {
    color: var(--ink-soft);
    max-width: 62ch;
    margin: 0 0 calc(var(--pas) * 4);
  }
  .reglages {
    display: flex;
    justify-content: flex-end;
  }
  .lignes {
    display: grid;
  }
  .ligne {
    display: grid;
    grid-template-columns: 1fr auto auto;
    align-items: center;
    gap: calc(var(--pas) * 3);
    padding: calc(var(--pas) * 1.5) 0;
    border-bottom: 1px solid var(--line);
  }
  .ligne:last-child {
    border-bottom: none;
  }
  .nom {
    font-family: 'Cinzel', serif;
    /* Le livre écrit les Caractéristiques en capitales : c'est une convention
       typographique, donc l'affaire de la feuille de style. */
    text-transform: uppercase;
    letter-spacing: 0.06em;
    font-size: 0.85rem;
  }
  .plafond {
    font-size: 0.75rem;
    color: var(--ink-soft);
    text-align: right;
    display: grid;
    white-space: nowrap;
  }
  .source {
    color: var(--gold);
    font-size: 0.68rem;
  }
</style>
